import { render, staticRenderFns } from "./LabTechnician.vue?vue&type=template&id=3c7617a4"
import script from "./LabTechnician.vue?vue&type=script&lang=js"
export * from "./LabTechnician.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports